import { createAction } from 'redux/helpers/actions';
import types from './types';

export default {
  getCollections: (data) => createAction(types.getCollections, data),
  getCollection: (data) => createAction(types.getCollection, data),
  getPageCollections: (data) => createAction(types.getPageCollections, data),
  getEntries: (data) => createAction(types.getEntries, data),
};
